import React from "react";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useDateFormatSelect } from "store";
import dayjs from "dayjs";

interface IProps {
  label: string;
  onChange: (value: string) => void;
  onClear: () => void;
  defaultValue: string;
}

export const DatePicker: React.FC<IProps> = ({ onClear, onChange, defaultValue, label }) => {
  const dateFormat = useDateFormatSelect();
  return (
    <DesktopDatePicker
      format={dateFormat}
      views={["year", "month", "day"]}
      slotProps={{
        inputAdornment: { position: "start" },
        popper: {
          sx: {
            minWidth: "335px",
            ".MuiPickersCalendarHeader-labelContainer": {
              fontSize: "0.9rem"
            }
          }
        },
        textField: {
          sx: { padding: 0, svg: { color: "#0a3142" } },
          placeholder: "dd / mm / yyyy",
          fullWidth: true
        },
        field: {
          clearable: true,
          onClear: () => onClear()
        }
      }}
      value={defaultValue ? dayjs(defaultValue) : null}
      label={label}
      onChange={(value) => {
        onChange(value ? value.toISOString() : "");
      }}
    />
  );
};
